//import './forms';

document.addEventListener( 'DOMContentLoaded', init );
function init() {

    const currentSite = `https://${window.location.host}`;

    const mainblockwrap = document.querySelector('.subscribe-form');
    const saveContactForm = document.getElementById( 'subscribe-contact-form' );
    const formMessages = mainblockwrap.querySelector('.form-messages');

    saveContactForm.addEventListener('submit', attemptSaveContact );

    const formTerms = saveContactForm.querySelector('input[name=Accept_Site_Terms]');
    formTerms.addEventListener('change', function(event) {
        if ( event.target.checked ) {
            event.target.classList.remove('invalid');
        } else {
            event.target.classList.add('invalid');
        }
    });

    const formEmail = saveContactForm.querySelector('input[type=email]');
    console.log(formEmail);
    if ( formEmail ) {
        console.log(formEmail);

        formEmail.addEventListener('blur', function() {

            const parentField = formEmail.closest('.form-input');
            if ( parentField ) {
                const existingValidation = parentField.querySelector('.validation-error');
                if ( existingValidation ) {
                    existingValidation.remove();
                }
            }

            validationElement = createValidationMessageElement();

            if ( ! validateEmail( formEmail.value ) ) {
                
                formEmail.classList.add('invalid');
                showMessageElement( formEmail, validationElement, "Please enter a valid email address" );

            } else {
                formEmail.classList.remove('invalid');
                validationElement.remove();
                resetValidationReport( saveContactForm );
            }
        });

        formEmail.addEventListener('input', function() {
            if ( ! validateEmail( formEmail.value ) ) {
                formEmail.classList.remove('invalid');
                validationElement.remove();
                resetValidationReport( saveContactForm );
            }
        });
    }

    function validateEmail(email) {
        const rE = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return rE.test(String(email).toLowerCase());
    }
    
    function createValidationMessageElement() {
        const element = document.createElement('span');
        element.classList.add('validation-error');
        return element;
    }
    
    function showMessageElement( formInput, element, message ) {
        element.innerText = message;
        formInput.before(element);
    }
    
    function isFormValid( event ) {
    
        const form = event.currentTarget;
        const invalidFields = form.querySelectorAll('.invalid');
        const existingErrors = form.querySelectorAll('.form-errors');
        if ( existingErrors.length > 0 ) {
            [...existingErrors].forEach( error => {
                error.remove();
            });
        }
    
        console.log(invalidFields);
        
        if ( invalidFields.length > 0 ) {
    
            event.preventDefault();
            
            const inputsWithErrorNoticeEl = document.createElement('div');
            inputsWithErrorNoticeEl.classList.add('form-errors');
    
            const inputsErrorHeading = document.createElement('h2');
            inputsErrorHeading.innerText = "Please review the following fields for errors";
            inputsWithErrorNoticeEl.appendChild(inputsErrorHeading);
    
            form.prepend(inputsWithErrorNoticeEl);
    
            const inputErrorListEl = document.createElement('ul');
            inputsWithErrorNoticeEl.appendChild(inputErrorListEl);
    
            [...invalidFields].forEach( field => {
                const inputGroup = field.closest('.form-input');
                const label = inputGroup.querySelector('label');
    
                const errorListEl = document.createElement('li');
                errorListEl.innerText = label.innerText
                inputErrorListEl.appendChild(errorListEl);
            });
    
            inputsWithErrorNoticeEl.scrollIntoView({  behavior: "smooth", block: "center" });

            return false;
        }

        return true;
    }
    
    function resetValidationReport( form ) {
    
        const invalidFields = form.querySelectorAll('.invalid');
        const report = form.querySelector('.form-errors');
    
        if ( invalidFields.length > 0 && report ) {
            report.remove();
        }
    }

    async function postData( url = '', post ) {

        const response = await fetch( url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body : JSON.stringify(post)
        });
        console.log(response);
        return response.json();
        
    }
    
    async function saveContact( post ) {
        console.log(post);
        const data = await postData( `${currentSite}/wp-json/acoustic-integration/v1/subscribe-to-acoustic`, post );
        console.log(data);
        return data;
    }
    
    async function attemptSaveContact(event) {
    
        event.preventDefault();

        formMessages.innerHTML = '';

        let validationElement;
        console.log(isFormValid( event ));
        if ( ! isFormValid( event ) ) {
            return false;
        }
    
        const formActions = mainblockwrap.querySelector('.form-actions');
        const listId = saveContactForm.querySelector('input[name=list_id]').value;
        const email = saveContactForm.querySelector('input[name=email]').value;
        const firstName = saveContactForm.querySelector('input[name=first_name]').value;
        const lastName = saveContactForm.querySelector('input[name=last_name]').value;
        const acceptTerms = saveContactForm.querySelector('input[name=Accept_Site_Terms]').value;

        let thirdPartyOpt = '';
        let sendOffers = '';

        if ( listId === '15758123' ) {
            sendOffers = saveContactForm.querySelector('input[name=send_offers]:checked');
            console.log(sendOffers);
            if ( sendOffers ) {
                sendOffers = sendOffers.value;
            }
        } else {
            thirdPartyOpt = saveContactForm.querySelector('input[name=opt_UKT_ThirdParty_Training]:checked');
            if ( thirdPartyOpt ) {
                thirdPartyOpt = thirdPartyOpt.value;
            }
        }

        // list 15758123
        const worksInTheatre = saveContactForm.querySelector('input[name=work_in_theatre]:checked');
        const amParent       = saveContactForm.querySelector('input[name=am_parent]:checked');
        const amTeacher      = saveContactForm.querySelector('input[name=am_teacher]:checked');
    
        formActions.classList.add('saving');
    
        const post = {
            ListId: listId,
            Email : email,
            FirstName : firstName,
            LastName : lastName,
            opt_UKT_ThirdParty_Training: thirdPartyOpt,
            Accept_Site_Terms: acceptTerms,
            send_offers: sendOffers
        }

        if ( worksInTheatre ) {
            post.work_in_theatre = 'yes';
        }

        if ( amParent ) {
            post.am_parent = 'yes';
        }

        if ( amTeacher ) {
            post.am_teacher = 'yes';
        }
        
        const messageEl = document.createElement('span');
        messageEl.classList.add('form-message-text');
        let messageText = '';

        const request = await saveContact( post );
        if ( request.success !== undefined && request.success ) {
            //console.log(request);
            saveContactForm.remove();

            formMessages.classList.add('success');
            messageText = "You've been subcribed to the list, thank you.";

        } else {    
            formMessages.classList.add('error');
            messageText = `Something went wrong, please try again or <a href="${currentSite}/contact">contact our support</a>`;
            //console.log(request,'failed');
        }

        messageEl.innerHTML = messageText;
        formMessages.append(messageEl)
    
        formActions.classList.remove('saving');
    }
}